<template>
  <div>
    <v-container>
      <h1 class="header-text">
        <span>
          <span v-if="!isUpdate">Kreiranje izvještaja</span>
          <span v-else>Uređivanje izvještaja</span>
          <div class="header-text-line"></div>
        </span>
      </h1>
      <v-flex xs12>
        <v-checkbox label="Susret održan" v-model="report.Held"></v-checkbox>
      </v-flex>
      <v-flex xs12>
        <v-textarea label="Komentar" v-model="report.Comment"></v-textarea>
      </v-flex>
      <v-flex xs12 class="text-right">
        <v-btn class="main-btn" @click="submitReport" v-if="!isUpdate">Podnesi izvještaj</v-btn>
        <v-btn class="main-btn" @click="updateReport" v-else>Uredi izvještaj</v-btn>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["appointmentUsersId", "isUpdate", "dialog"],
  data() {
    return {
      report: {}
    };
  },
  methods: {
    getReport() {
      this.$store.state.services.reportService
        .get(this.appointmentUsersId)
        .then(response => {
          this.report = response.data || {};
        });
    },
    submitReport() {
      this.report.AppointmentUsersId = this.appointmentUsersId;
      this.$store.state.services.reportService
        .add(this.report)
        .then(result => {
          this.$emit("refreshData");
          this.$store.dispatch("setResponseMessage",result.data);
        })
        .catch(err => {});
    },
    updateReport() {
      this.$store.state.services.reportService
        .update(this.report)
        .then(result => {
          this.$emit("closeDialog");
          this.$emit("refreshData");
          this.$store.dispatch("setResponseMessage",result.data);
        })
        .catch(err => {});
    }
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.report = {};
      }
      else if(this.isUpdate){
        this.getReport();
      }
    }
  }
};
</script>

<style scoped>
</style>
